module.exports = __webpack_public_path__ + "img/WhereIsNFDI.55b4fe73.png";